var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useLanguage } from '@base/LanguageProvider';
var STATUS_CONTAINER_STYLE = {
    paddingRight: 6,
    paddingLeft: 6,
    borderRadius: 6,
    fontSize: 12,
};
export function Status(_a) {
    var status = _a.status, style = _a.style, Icon = _a.Icon, iconStyle = _a.iconStyle;
    var L = useLanguage().L;
    var mergedStyle = __assign(__assign({}, STATUS_CONTAINER_STYLE), style);
    return (React.createElement("span", { style: mergedStyle },
        Icon && React.createElement(Icon, { style: iconStyle }),
        L(status)));
}
